'use client'
import React, { useCallback, useMemo } from 'react'

import { Category } from '@/payload-types'
import { usePathname, useSearchParams, useRouter } from 'next/navigation'

import { filterPill } from './filter/FilterItem'

type Props = {
  category: Category
}

/** Категория-пилюля. Повторный клик по выбранной снимает фильтр. */
export const CategoryItem: React.FC<Props> = ({ category }) => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()

  const isActive = useMemo(() => searchParams.get('category') === String(category.id), [category.id, searchParams])

  const setQuery = useCallback(() => {
    const params = new URLSearchParams(searchParams.toString())
    if (isActive) params.delete('category')
    else params.set('category', String(category.id))
    const query = params.toString()
    router.push(query ? `${pathname}?${query}` : pathname)
  }, [category.id, isActive, pathname, router, searchParams])

  return (
    <button type="button" onClick={setQuery} aria-pressed={isActive} className={`${filterPill(isActive)} cursor-pointer`}>
      {category.title}
    </button>
  )
}

/** Кнопка сброса категории — «Всё» рядом со списком. */
export const CategoryReset: React.FC = () => {
  const router = useRouter()
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const isActive = !searchParams.get('category')

  const reset = useCallback(() => {
    const params = new URLSearchParams(searchParams.toString())
    params.delete('category')
    const query = params.toString()
    router.push(query ? `${pathname}?${query}` : pathname)
  }, [pathname, router, searchParams])

  return (
    <button type="button" onClick={reset} aria-pressed={isActive} className={`${filterPill(isActive)} cursor-pointer`}>
      Всё
    </button>
  )
}
